import Axios from "axios"

export default {
    addZoneNote(_zoneID, _email, _notes) {
        return Axios.post(
            "/addZoneNote",
            {
                zoneID: _zoneID,
                email: _email,
                notes: _notes
            },
            {
                headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
            }
        )
    },
    editZoneNote(_zoneNoteID, _notes) {
        return Axios.post(
            "/editZoneNote",
            {
                zoneNoteID: _zoneNoteID,
                notes: _notes
            },
            {
                headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
            }
        )
    },
    deleteZoneNote(_zoneNoteID) {
        return Axios.post(
            "/deleteZoneNote",
            {
                zoneNoteID: _zoneNoteID
            },
            {
                headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
            }
        )
    },
    getZoneNotes(_zoneID) {
        var config = {
            headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
        }
        return Axios.post("/getZoneNotes", { zoneID: _zoneID, }, config)
    },
}



// WEBPACK FOOTER //
// ./src/api/notes.service.js